import { defineSlotRecipe } from "@pandacss/dev";

const slots = [
  "content",
  "backdrop",
  "positioner",
  "closeTrigger",
  "header",
  "body",
  "footer",
];

export const aromaDrawer = defineSlotRecipe({
  className: "aroma-drawer",
  jsx: ["Drawer", "Footer", "Header", "DrawerCloseTrigger"],
  slots: slots,
  base: {
    backdrop: {
      backdropFilter: "blur(4px)",
      bgColor: "background.neutral.overlay.bold",
      height: "100%",
      left: "0",
      position: "fixed",
      top: "0",
      width: "100%",
      zIndex: "var(--backdrop-z-index)",
      _open: {
        animation: "fadeIn 0.25s ease-in",
      },
      _close: {
        animation: "fadeOut 0.2s ease-out",
      },
      pointerEvents: "all",
    },
    positioner: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "flex-end",
      position: "fixed",
      top: 0,
      right: 0,
      width: "100%",
      zIndex: "var(--drawer-z-index)",
      pointerEvents: "none",
    },
    content: {
      background: "background.neutral.base.subtlest",
      boxShadow: "effect.shadow.bolder-bottom",
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "auto 1fr auto",
      gridTemplateAreas: `
        'header'
        'body'
        'footer'
      `,
      height: "100%",
      borderLeftRadius: "2xl",
      clipPath: "border-box",
      position: "relative",
      animationDuration: "0.3s",
      animationTimingFunction: "ease-in-out",
      _open: {
        animationName: "slide-in-right",
      },
      _close: {
        animationName: "slide-out-right",
      },
      '& [data-part="close-trigger"]': {
        position: "absolute",
        top: "padding.2",
        right: "padding.2",
      },
    },
    header: {
      gridArea: "header",
      display: "flex",
      padding: "padding.2",
      gap: "gap.2",
      justifyContent: "space-between",
      alignItems: "center",
      textStyle: "title.m",
      color: "content.neutral.base.bold",
      borderColor: "border.neutral.subtle",
      borderBottomWidth: "m",
      borderBottomStyle: "solid",
      '& [data-part="close-trigger"]': {
        position: "initial",
      },
    },
    body: {
      gridArea: "body",
      overflow: "auto",
    },
    footer: {
      gridArea: "footer",
      display: "flex",
      padding: "padding.4",
      gap: "gap.2",
      justifyContent: "flex-end",
      alignItems: "center",
      color: "content.neutral.base.subtlest",
    },
  },
  variants: {
    size: {
      full: {
        content: {
          width: "100%",
          mt: "48px",
          height: "calc(100% - 48px)",
          borderBottomLeftRadius: "0",
          borderTopRightRadius: "2xl",
          _open: {
            animationName: "slide-in-bottom",
          },
          _close: {
            animationName: "slide-out-bottom",
          },
        },
        closeTrigger: {
          cursor: "pointer",
          position: "absolute",
          top: "padding.3",
          right: "50%",
          _before: {
            content: "''",
            display: "block",
            width: "xl",
            height: "{borderWidths.2xl}",
            borderRadius: "pill",
            bgColor: "background.neutral.base.subtle",
            transform: "translateX(50%)",
          },
        },
      },
      small: {
        content: {
          width: "width.s",
        },
      },
      medium: {
        content: {
          width: "width.m",
        },
      },
      large: {
        content: {
          width: "width.l",
        },
      },
    },
    stackedActions: {
      true: {},
    },
  },
  defaultVariants: {
    size: "medium",
  },
  compoundVariants: [
    {
      size: "full",
      stackedActions: true,
      css: {
        footer: {
          flexDirection: "column-reverse",
        },
      },
    },
  ],
});
